export enum Products {
  LOC = 1,
  REFI = 2,
  PEL = 3,
}

export enum ApplicationStatuses {
  NOT_SUBMITTED = 1,
  EVALUATION = 2,
  SUBMITTED_AND_PROCESSING = 3,
  COMPLETE = 4,
  DECLINED = 5,
  CANCELLED = 6,
  SMR_DECLINED = 7,
  RIGHT_TO_CANCEL = 8,
  SCHOOL_CERTIFICATION = 9,
}
export enum DocumentStatuses {
  UploadedUnavailable = 1,
  UploadedAvailable = 2,
  UploadedVerified = 3,
  Generated = 4,
  Signed = 5,
  Error = 6,
}
export enum CitizenshipStatusTypes {
  USCitizen = 1,
  PermanentResident = 2,
  NonCitizen = 3,
  NonUSCitizenWithSSN = 4,
}

export enum ConsentServiceEntityTypes {
  Application = 1,
  Loan = 2,
  Draw = 3,
}

export enum RepaymentTerms {
  FIVE = 1,
  SEVEN = 2,
  TEN = 3,
  FIFTEEN = 4,
  TWENTY = 5,
  TWENTY_FIVE = 6,
  THREE = 7,
  TEN_AND_HALF = 8,
  TWELVE = 9,
}

export enum RepaymentTypes {
  Flat = 1,
  Deferred = 2,
  Interest = 3,
  Regular = 4,
}

export enum StipulationStatuses {
  OPEN = 1,
  COMPLETED = 2,
  CU_OVERRIDE = 3,
  CANCELLED = 4,
  PENDING = 5,
}

export enum StipulationTypesEnum {
  W2 = 1,
  Paystub = 2,
  EmployerLetter = 3,
  OtherIncome = 4,
  TaxReturn = 5,
  ScheduleC = 6,
  ScheduleK1 = 7,
  ScheduleE = 8,
  ScheduleF = 9,
  BankStatement = 10,
  BenefitAwardLetter = 11,
  SSA1099 = 12,
  R1099 = 13,
  ScheduleB = 14,
  DivorceInfo = 15,
  ChildSupport = 16,
  Disability = 17,
  AdditionalIncome = 18,
  ProofOfCitizenship = 19,
  CitizenshipRenewal = 20,
  EstablishMembership = 21,
  MaintainMembership = 22,
  MembershipAttestation = 23,
  StateIssuedID = 24,
  Passport = 25,
  BirthCertificate = 26,
  SchoolID = 27,
  SocialSecurityCard = 28,
  TaxFormNameSSN = 29,
  OtherIDVerification = 30,
  VerbalAddressVerification = 31,
  SpousalConsent = 32,
  FinalReview = 33,
  CompleteLoanConfiguration = 34,
  ConfirmLoanConfiguration = 35,
  ExecuteLegalDocPackage = 36,
  SSNMismatch = 37,
  CreditFreeze = 38,
  Deceased = 39,
  ConsumerStatement = 40,
  NoHit = 41,
  UnfreezeCredit = 42,
  UnSuppressBureau = 43,
  ContactCBRCorrection = 44,
  Other = 45,
  OtherInternal = 46,
  OtherInternalDoc = 47,
  ExtensiontoFileFITR = 48,
  ADDMismatch = 49,
  SSNMistmatchProofSSN = 50,
  EFileConfirmationTaxReturn = 51,
  ITINLetterOrCard = 52,
  GovIssuedID = 53,
  USResidency = 54,
  PrintAndMailSpousalConsent = 55,
  ZIPMismatch = 56,
  NameVerification = 57,
  AddressVerification = 58,
  DateOfBirthVerification = 59,
  SSNVerification = 60,
  ProofOfAddress = 61,
  ConfirmPayoffRequest = 62,
  LoanAccountStatement = 63,
  Schedule1 = 64,
  PayoffStatement = 65,
  ProofOfGraduation = 66,
  LoanResponsibilityAffidavit = 67,
  ResponsibilityForUnderPayment = 68,
  RateTermSelection = 69,
  ConfirmationEsign = 70,
  ServicerPayoffAddress = 71,
  ValidateEmployment = 72,
  RateTermRepaymentSelection = 73,
  SelfCertificationDetails = 74,
  SSN12ProcessorUpdate = 75,
  PilotLicense = 76,
  NursingLicense = 77,
  VerifyMonthsSinceGraduation = 78,
  InsuranceOrMedicalLicense = 79,
  AutomatedIncomeVerificationConsent = 80,
  IncomeVerification = 81,
  NonIncomeResponsibleApplicant = 82,
}

export enum DocumentTypes {
  FinalDisclosure = 52,
  AdverseAction = 25,
}

export type DocumentTypeNames = keyof typeof DocumentTypes;

export const PayoffVerificationStipulationTypes = [
  StipulationTypesEnum.ConfirmPayoffRequest,
  StipulationTypesEnum.LoanAccountStatement,
  StipulationTypesEnum.PayoffStatement,
  StipulationTypesEnum.LoanResponsibilityAffidavit,
  StipulationTypesEnum.ResponsibilityForUnderPayment,
  StipulationTypesEnum.ServicerPayoffAddress,
];

export const IncomeStipulationTypes = [
  StipulationTypesEnum.W2,
  StipulationTypesEnum.Paystub,
  StipulationTypesEnum.EmployerLetter,
  StipulationTypesEnum.OtherIncome,
  StipulationTypesEnum.TaxReturn,
  StipulationTypesEnum.ScheduleC,
  StipulationTypesEnum.ScheduleK1,
  StipulationTypesEnum.ScheduleE,
  StipulationTypesEnum.ScheduleF,
  StipulationTypesEnum.BankStatement,
  StipulationTypesEnum.BenefitAwardLetter,
  StipulationTypesEnum.SSA1099,
  StipulationTypesEnum.R1099,
  StipulationTypesEnum.ScheduleB,
  StipulationTypesEnum.DivorceInfo,
  StipulationTypesEnum.ChildSupport,
  StipulationTypesEnum.Disability,
  StipulationTypesEnum.AdditionalIncome,
  StipulationTypesEnum.ExtensiontoFileFITR,
  StipulationTypesEnum.EFileConfirmationTaxReturn,
  StipulationTypesEnum.Schedule1,
  StipulationTypesEnum.AutomatedIncomeVerificationConsent,
  StipulationTypesEnum.IncomeVerification,
  StipulationTypesEnum.NonIncomeResponsibleApplicant,
  StipulationTypesEnum.ExtensiontoFileFITR,
  StipulationTypesEnum.AutomatedIncomeVerificationConsent,
  StipulationTypesEnum.IncomeVerification,
  StipulationTypesEnum.NonIncomeResponsibleApplicant,
];

export const RegulatoryStipulationTypes = [StipulationTypesEnum.SelfCertificationDetails];

export const EsignStipulationTypes = [
  StipulationTypesEnum.ConfirmationEsign,
  StipulationTypesEnum.ExecuteLegalDocPackage,
];

export const IdentityStipulationTypes = [
  StipulationTypesEnum.StateIssuedID,
  StipulationTypesEnum.Passport,
  StipulationTypesEnum.BirthCertificate,
  StipulationTypesEnum.SchoolID,
  StipulationTypesEnum.SocialSecurityCard,
  StipulationTypesEnum.TaxFormNameSSN,
  StipulationTypesEnum.OtherIDVerification,
  StipulationTypesEnum.NameVerification,
  StipulationTypesEnum.AddressVerification,
  StipulationTypesEnum.DateOfBirthVerification,
  StipulationTypesEnum.SSNVerification,
  StipulationTypesEnum.ProofOfAddress,
  StipulationTypesEnum.ITINLetterOrCard,
];

export enum ProcessingCategories {
  Income = 1,
  Citizenship = 2,
  Membership = 3,
  Identity = 4,
  SpousalConsent = 5,
  FinalReview = 6,
  LoanConfiguration = 7,
  ESign = 8,
  Credit = 9,
  Misc = 10,
  PayoffVerification = 11,
  EligibilityVerification = 12,
  RateTerm = 13,
  Employment = 14,
  Regulatory = 15,
}

export enum SurveyQuestionTypes {
  TwoYearsIncome = 1,
  SelectedCreditRange = 2,
  MaritalStatus = 3,
  SMREstimateLoanAmount = 4,
  EmploymentStatus = 5,
  EmployerName = 6,
}

export enum IncomeSourceTypes {
  PAYSTUB = 1,
  SCHEDULE_C = 2,
  SOCIAL_SECURITY_BENEFITS = 3,
  RETIREMENT = 4,
  SCHEDULE_E = 5,
  OTHER_INCOME = 6,
}

export enum ApplicantTypes {
  PRIMARY_APPLICANT = 1,
  CO_APPLICANT = 2,
}

export enum ConsentTypes {
  CREDIT = 1,
  ECOMMUNICATION = 2,
  MOBILE = 3,
  TERMS_AND_CONDITIONS = 4,
  EMAIL_VALIDATION = 5,
  SOFT_PULL = 6,
  REFI_UNDERPAYMENT = 7,
  SLR_PAYOFF_CONFIRMATION = 8,
  CONFIRMATION_OF_LOAN_TERMS = 11,
  PARENT_ATTESTATION = 13,
}

export enum AddressStates {
  CALIFORNIA = 6,
}

export enum AddressTypes {
  PermanentAddress = 1,
  PreviousAddress = 5,
}

export enum AddressCountries {
  USA = 1,
}

export enum LocStatusTypes {
  OPEN = 1,
  CLOSED = 2,
}

export enum ReapplyButtonActions {
  CLOSE = 0,
  CANCELSLC = 1,
  CANCELCONTINUE = 2,
}

export enum Flows {
  STRICT = 1,
  MDDO = 2,
  MEDICAL = 3,
  PROF = 4,
}

export enum Programs {
  UNDERGRADUATE = 1,
  DOMESTIC_GRADUATE = 2,
  INTERNATIONAL_GRADUATE = 3,
  PARENT = 4,
  ADVANCED_DEGREE = 5,
  MEDICAL = 6,
  STANDARD = 7,
  INTERNATIONAL_UNDERGRADUATE = 8,
  DOMESTIC_GRADUATE2 = 9,
  BIO_MEDICAL1 = 10,
  REACH = 11,
  AVIATION1 = 12,
  AVIATION2 = 13,
  AVIATION3 = 14,
  AVIATION4 = 15,
  AVIATION5 = 16,
  BIO_MEDICAL2 = 17,
  BIO_MEDICAL3 = 18,
  MEDICAL2 = 19,
  MEDICAL3 = 20,
  NURSING1 = 21,
  NURSING2 = 22,
  NURSING3 = 23,
  ENERGY_TRADE_SCHOOL1 = 24,
  ENERGY_TRADE_SCHOOL2 = 25,
  ENERGY_TRADE_SCHOOL3 = 26,
  DENTAL = 27,
  DENTAL2 = 28,
  DENTAL3 = 29,
  PODIATRY = 30,
  PODIATRY2 = 31,
  PODIATRY3 = 32,
  OPTOMETRY = 33,
  OPTOMETRY2 = 34,
  OPTOMETRY3 = 35,
  VETERINARY_MEDICINE = 36,
  VETERINARY_MEDICINE2 = 37,
  VETERINARY_MEDICINE3 = 38,
  LAW = 39,
  LAW2 = 40,
  LAW3 = 41,
  THEOLOGY = 42,
  THEOLOGY2 = 43,
  THEOLOGY3 = 44,
  PHARMACY = 45,
  PHARMACY2 = 46,
  PHARMACY3 = 47,
  CLINICAL_PSYCHOLOGY = 48,
  CLINICAL_PSYCHOLOGY2 = 49,
  CLINICAL_PSYCHOLOGY3 = 50,
  BAR_STUDY = 51,
  BAR_STUDY2 = 52,
  BAR_STUDY3 = 53,
  MEDICAL_OSTEOPATHIC = 54,
  MEDICAL_OSTEOPATHIC2 = 55,
  MEDICAL_OSTEOPATHIC3 = 56,
  MEDICAL_AND_OSTEOPATHIC = 57,
  MEDICAL_AND_OSTEOPATHIC2 = 58,
  MEDICAL_AND_OSTEOPATHIC3 = 59,
  LANDSCAPING = 60,
  ADVANCED_DEGREE2 = 61,
  ADVANCED_DEGREE3 = 62,
  HEALTH_PROFESSIONS = 63,
  HEALTH_PROFESSIONS2 = 64,
  HEALTH_PROFESSIONS3 = 65,
}

export enum SchoolTypes {
  AVIATION = 25,
}